export default "__VITE_ASSET__9b7cc820__"